import Skeleton from 'react-loading-skeleton';
import styled, { CSSProperties, useTheme } from 'styled-components';
import { ReactNode } from 'react';
import { theme } from '../../theme/theme';

const StyledSkeletonWrapper = styled.span<{ $width?: string; $height?: string }>`
	width: ${({ $width }) => $width};
	height: ${({ $height }) => $height};
	display: inline-block;
`;

interface SkeletonProps {
	baseColor?: keyof typeof theme;
	highlightColor?: keyof typeof theme;
	width?: string;
	height?: string;
	style?: CSSProperties;
}
export function LoadingSkeleton(props: SkeletonProps) {
	const { baseColor, highlightColor, style, width, height } = props;
	const theme = useTheme();
	return (
		<StyledSkeletonWrapper $width={width} $height={height} className="skeleton">
			<Skeleton
				width={width}
				height={height}
				baseColor={baseColor ? theme[baseColor] : 'rgba(255, 255, 255, 0.1)'}
				highlightColor={highlightColor ? theme[highlightColor] : 'rgba(255, 255, 255, 0.05)'}
				borderRadius="4px"
				style={style && style}
			/>
		</StyledSkeletonWrapper>
	);
}

export function TextSkeleton({
	children,
	width,
	height,
}: {
	children: ReactNode | undefined;
	width: string;
	height?: string;
}) {
	return children ? children : <LoadingSkeleton width={width} height={height ?? '26.5px'} />;
}
